import { Component, OnInit } from '@angular/core';
import { LoaderService } from '../../shared/services/loader.service';
import { OverviewService } from '../shared/overview.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss']
})
export class OverviewComponent implements OnInit {

  nbActiveUsersInLast30Days: number;
  nbLoginsLastMonth: number;
  nbLoginsLastWeek: number;

  constructor(private overviewServie: OverviewService, private loader: LoaderService) {
  }

  ngOnInit() {
    this.loader.startLoad(false);

    this.overviewServie.getOverview()
      .pipe(finalize(() => this.loader.stopLoad()))
      .subscribe(o => {
        this.nbActiveUsersInLast30Days = o.nb_active_users_in_last30_days;
        this.nbLoginsLastMonth         = o.nb_logins_last_month;
        this.nbLoginsLastWeek          = o.nb_logins_last_week;
      });
  }

}
